import React from "react";
import { MimaButton, MimaText, Modal } from "../../components";
import { Formik } from "formik";

const DeleteSubDomain = ({
    data,
    closeModal,
    onSubmit,
    loading,
}) => {

    return (
        <Modal closeModal={closeModal}>
            <> {
                data.storeFrontUrl ?
                <Formik
                initialValues={{

                }}
                onSubmit={onSubmit}
            >
                {({
                    handleSubmit }) => (
                    <>
                        <MimaText>{`Are you sure you want to delete ${data.tradingName} website url: ${data.storeFrontUrl}?`}</MimaText>
                        <MimaButton
                            title="Delete"
                            type="submit"
                            onClick={handleSubmit}
                            mt={2}
                            width="38"
                            buttonColor="#60607A"
                            loading={loading}
                        />
                    </>
                )}

            </Formik>
            : (<MimaText>{`${data.tradingName} does not have a website configured`}</MimaText>)
            }
               
            </>
        </Modal>
    )
}
export default DeleteSubDomain;